/* istanbul ignore file */
/**
 * Authorization Roles
 */
export const USER_ROLES = {
	OWNER: 'c-owner',
	LANGOPS: 'c-langops',
	ADMIN: 'c-admin',
	AGENT_ADMIN: 'c-ag-admin',
	AGENT: 'c-agent',
	CSM: 'u-csm',
	IMPLEMENTATION: 'u-implementation',
	CONTENT_SUBMITTER: 'c-content-submitter',
	CONTENT_SUBMITTER_RESTRICTED: 'c-content-submitter-restricted',
	LANGOS_APP: 'u-langos-app',
	OPS: 'u-ops',
};
